import { combineNullableStrings } from "./internal/combineNullableStrings.js";
const combineClasses = (...arguments_)=>combineNullableStrings(...arguments_) ?? '';
export { combineClasses };
